import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { logError } from 'lib/sentry/logError';
import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';
import { Nullable } from 'shared_DEPRECATED/types';
import { Attachment } from 'shared_DEPRECATED/types/Attachment';
import { LinkPreview } from 'types/common';

import { useChatInterlocutorContext } from 'features/chat/context/chatInterlocutor';

export const useChatMessageScheduleEdit = () => {
  const { chatId } = useChatInterlocutorContext();
  const { request } = useMutationHTTPRequest();
  const queryClient = useQueryClient();

  return useMutation(
    async ({
      messageId,
      scheduledFor,
      text,
      replyTo,
      attachments,
      linkPreview,
    }: {
      messageId: string;
      scheduledFor?: string;
      text?: string;
      replyTo?: string | null;
      attachments?: Attachment[];
      linkPreview: Nullable<LinkPreview>;
    }) =>
      request({
        url: `/api/chats/${chatId}/scheduled-messages/${messageId}/edit`,
        body: {
          scheduledFor,
          text,
          replyTo,
          attachments,
          linkPreview,
        },
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries([queryKeys.scheduledMessages, chatId]);
      },
      onError: (error) => {
        logError(error);
      },
    }
  );
};
